import { useQuery, type QueryHookOptions } from '@apollo/client';
import { graphql } from '@/gql/__codegen__';
import type {
  PointChargeTop_PointChargeProductsQuery,
  PointChargeTop_PointChargeProductsQueryVariables,
} from '@/gql/__codegen__/graphql';

graphql(`
  fragment PointChargeTop_PointChargeProduct on PointChargeProduct {
    __typename
    productId
    productName
    salePrice
    pointAmount
  }
`);

const QUERY = graphql(`
  query pointChargeTop_pointChargeProducts {
    pointChargeProducts {
      products {
        ...PointChargeTop_PointChargeProduct
      }
    }
  }
`);

type HookOptions = QueryHookOptions<
  PointChargeTop_PointChargeProductsQuery,
  PointChargeTop_PointChargeProductsQueryVariables
>;

export function usePointChargeProductsQuery(options?: HookOptions) {
  return useQuery(QUERY, {
    ...options,
  });
}
